/**
 * BingX Exchange Metadata
 *
 * Configuration, documentation links, and notes for the BingX exchange.
 */

import { BINGX_WS_CHANNELS, BINGX_WS_TOPOLOGY } from './ws';

import type { ExchangeId, ExchangeMetadata } from '../../lib/types';

export const BINGX_METADATA: ExchangeMetadata = {
  id: 'bingx' as ExchangeId,
  restDocs: ['https://bingx-api.github.io/docs/#/en-us/spot/market-api.html'],
  wsDocs: ['https://bingx-api.github.io/docs/#/spot/websocket/market-api.html'],
  wsTopology: BINGX_WS_TOPOLOGY,
  wsChannels: BINGX_WS_CHANNELS,
  notes: [
    'All WebSocket messages are gzip-compressed.',
    'Symbol format: BASE-QUOTE (e.g., BTC-USDT)',
    'Server sends ping frames; must respond with pong to keep connection alive.',
  ],
};
